<div class="landing-container" fxLayout="column" fxLayoutAlign="start" fxLayoutGap="1%">
  <div class="dashboard-chart-master-container" [class.chart-collapsed]="chartCollapse">
    <div class="frosted-glass dashboard-chart-container">
      <div class="dashboard-header" fxLayout="row" fxLayoutAlign="start center">
        <div class="dashboard-header-text" fxFlex *ngIf="finfraMenuService.currentApplication">
          {{finfraMenuService.currentApplication.description}}</div>
        <div class="spacer"></div>
        <div class="dashboard-header-collapse-button" fxFlex fxLayoutAlign="end" (click)="collapseChart()"
          *ngIf="!finfraDashboardContainerService.chartCollapse">
          <mat-icon>expand_less</mat-icon>
        </div>
        <div class="dashboard-header-collapse-button" fxFlex fxLayoutAlign="end" (click)="collapseChart()"
          *ngIf="finfraDashboardContainerService.chartCollapse">
          <mat-icon>expand_more</mat-icon>
        </div>
      </div>
      <div *ngIf="functionId && panelLoaded" class="dashboard-chart-body" [class.collapse]="chartCollapse" fxLayout="row"
        fxLayout.lt-sm="column" fxLayoutAlign="start center" fxLayoutAlign.lt-sm="start" fxLayoutGap="1%">
        <finfra-ageing-chart-widget *ngIf="!finfraDashboardContainerService.chartCollapse" [functionId]="functionId">
        </finfra-ageing-chart-widget>
        <finfra-function-count-chart *ngIf="!finfraDashboardContainerService.chartCollapse" [functionId]="functionId">
        </finfra-function-count-chart>
      </div>
    </div>
  </div>

  <div class="dashboard-body">
    <mat-drawer-container>
      <mat-drawer position="start" mode="over" [(opened)]="finfraDashboardService.filterDrawer"
        class="dashboard-filter-drawer">
        <div class="dashboard-filter-drawer-content" fxLayout="column" fxLayoutGap="1%">
          <div class="dashboard-filter-drawer-header" fxLayout="row" fxLayoutGap="1%" fxLayoutAlign="start center">
            <div fxFlex fxLayoutAlign="start">
              <mat-icon>filter_alt</mat-icon>
            </div>
            <div fxFlex fxLayoutAlign="start" class="dashboard-filter-drawer-header-text">
              {{'filter'|translateLabel:translateLabelsName:translateLabelsLoaded}}</div>
            <div fxFlex class="spacer"></div>
            <div fxFlex fxLayoutAlign="end" class="dashboard-filter-drawer-header-close"
              (click)="finfraDashboardService.toggleDrawer()">
              <mat-icon>close</mat-icon>
            </div>
          </div>
          <div>
            <finfra-filter *ngIf="finfraDashboardService.filterDrawer" [functionId]="functionId"></finfra-filter>
          </div>
        </div>
      </mat-drawer>

      <mat-drawer-content class="dashboard-body-content">
        <div class="dashboard-filters-bar" *ngIf="finfraDashboardService.configData" fxLayout="row wrap"
          fxLayout.lt-sm="column" fxLayoutAlign="start center" fxLayoutAlign.lt-sm="start" fxLayoutGap="1%">
          <div class="dashboard-filter-button">
            <button mat-flat-button color="primary" (click)="finfraDashboardService.toggleDrawer()">
              <mat-icon>filter_alt</mat-icon>
            </button>
          </div>

          <div fxLayout="row wrap" fxLayout.lt-sm="row">
            <div class="dashboard-filter-bar-search-by">
              <finfra-transaction-searchby-dashboard-widget [functionId]="functionId">
              </finfra-transaction-searchby-dashboard-widget>
            </div>
          
            <div class="dashboard-filter-bar-search">
              <finfra-search-dashboard-widget [functionId]="functionId"></finfra-search-dashboard-widget>
            </div>
          </div>

          <div class="dashboard-filters-applied-container">
            <mat-chip-list class="dashboard-filters-applied">
              <ng-container *ngFor="let filter of finfraDashboardService.filters">
                <mat-chip *ngIf="filter.show" matTooltip="{{filter.tooltip}}">{{'' +
                  filter.label|translateLabel:translateLabelsName:translateLabelsLoaded}} <mat-icon matChipRemove
                    *ngIf="filter.closable" (click)="removeFilter(filter)">cancel</mat-icon>
                </mat-chip>
              </ng-container>
            </mat-chip-list>
          </div>

          <div class="spacer"></div>

          <div>
            <finfra-start-transaction [functionId]="functionId"></finfra-start-transaction>
          </div>
        </div>

        <div>
          <finfra-transaction-list [functionId]="functionId"></finfra-transaction-list>
        </div>
      </mat-drawer-content>
    </mat-drawer-container>
  </div>
</div>

<div class="dashboard-footer mat-elevation-z0" *ngIf="finfraDashboardService.showFooter">
  <div>
    <finfra-transaction-footer-dashboard-widget [functionId]="functionId"></finfra-transaction-footer-dashboard-widget>
  </div>
</div>